import { render } from "./CharlaPrivacyPopup.vue?vue&type=template&id=240de462&scoped=true"
import script from "./CharlaPrivacyPopup.vue?vue&type=script&lang=js"
export * from "./CharlaPrivacyPopup.vue?vue&type=script&lang=js"

import "./CharlaPrivacyPopup.vue?vue&type=style&index=0&id=240de462&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240de462"]])

export default __exports__